import React from 'react'
import PropTypes from 'prop-types'

import TextField from '../TextField'
import { AutocompleteClearButton, AutocompleteToggleButton } from './AutocompleteButton'

const getIcon = ({
  icon,
  selectedItem,
  clearLabel,
  clearSelection,
  getToggleButtonProps
}) => {
  if (icon) return icon

  return selectedItem
    ? <AutocompleteClearButton onClick={clearSelection} aria-label={clearLabel} />
    : <AutocompleteToggleButton {...getToggleButtonProps()} />
}

function AutocompleteTextField({
  icon,
  selectedItem,
  clearLabel,
  clearSelection,
  getToggleButtonProps,
  ...props
}) {
  const inputSuffix = getIcon({
    icon,
    selectedItem,
    clearLabel,
    clearSelection,
    getToggleButtonProps
  })

  return (
    <TextField
      {...props}
      suffix={inputSuffix}
    />
  )
}

const sharedPropTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.bool
  ]),
  selectedItem: PropTypes.any,
  clearLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]).isRequired,
  clearSelection: PropTypes.func.isRequired,
  getToggleButtonProps: PropTypes.func.isRequired
}

getIcon.propTypes = sharedPropTypes
AutocompleteTextField.propTypes = sharedPropTypes
AutocompleteTextField.defaultProps = {
  clearLabel: 'Eliminar selección'
}

export default AutocompleteTextField
